import { useEffect, useState, useRef } from "react";
import { getUpdatedAttributes } from "src/components/TagsEditor/utils/getUpdatedAttributes";

export const useAttributesUpdater = ({
  entityId,
  initialAttributes,
  selectedTag,
}: {
  entityId?: string;
  initialAttributes?: Record<string, unknown>;
  selectedTag?: {
    id?: string;
    attributes?: Record<string, unknown> | null;
  } | null;
}) => {
  const previousSelectedTag = useRef(selectedTag);
  const [updatedAttributes, setUpdatedAttributes] = useState(
    initialAttributes || {}
  );
  useEffect(() => {
    if (selectedTag && previousSelectedTag?.current?.id !== selectedTag?.id) {
      previousSelectedTag.current = selectedTag;
      const nextAttributes = getUpdatedAttributes({
        attributes: updatedAttributes,
        tagType: selectedTag as Parameters<
          typeof getUpdatedAttributes
        >[0]["tagType"],
        ...(entityId !== undefined ? { entityId } : {}),
      } as Parameters<typeof getUpdatedAttributes>[0]);
      setUpdatedAttributes(nextAttributes ?? updatedAttributes);
    }
  }, [selectedTag, entityId, previousSelectedTag, updatedAttributes]);

  return {
    updatedAttributes,
    setUpdatedAttributes,
  };
};
